import { useState, useCallback } from "react";
import { Button, Table, Text } from "@radix-ui/themes";
import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { TenantBrand } from "@/v2/entities/brand/Brand.model";
import { EditBrandDialog } from "./EditBrandDialog";
import { DeleteBrandDialog } from "./DeleteBrandDialog";
import { useBrandApi } from "@/v2/entities/brand/Brand.api";

interface BrandItemProps {
  brand: TenantBrand;
  refetch: () => void;
}

export function BrandItem({ brand, refetch }: BrandItemProps) {
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const handleEditClick = useCallback(() => {
    setEditDialogOpen(true);
  }, []);

  const handleDeleteClick = useCallback(() => {
    setDeleteDialogOpen(true);
  }, []);

  const formatDate = useCallback((dateString: string) => {
    return new Date(dateString).toLocaleDateString();
  }, []);

  return (
    <>
      <Table.Row>
        <Table.Cell>
          <Text size="2" weight="medium">
            {brand.name}
          </Text>
        </Table.Cell>
        <Table.Cell>
          <Text size="2" color="gray">
            {brand.subdomain}
          </Text>
        </Table.Cell>
        <Table.Cell>
          <Text size="1" color="gray" className="font-mono">
            {brand.externalId}
          </Text>
        </Table.Cell>
        <Table.Cell>
          <Text size="2" color="gray">
            {formatDate(brand.createdAt)}
          </Text>
        </Table.Cell>
        <Table.Cell className="text-right">
          <div className="flex gap-1 justify-end">
            <Button
              size="1"
              variant="ghost"
              color="gray"
              onClick={handleEditClick}
            >
              <Pencil1Icon />
            </Button>
            <Button
              size="1"
              variant="ghost"
              color="red"
              onClick={handleDeleteClick}
            >
              <TrashIcon />
            </Button>
          </div>
        </Table.Cell>
      </Table.Row>

      <EditBrandDialog
        open={editDialogOpen}
        onOpenChange={setEditDialogOpen}
        brand={brand}
        refetch={refetch}
      />

      <DeleteBrandDialog
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
        brand={brand}
        refetch={refetch}
      />
    </>
  );
}
